module.exports = __webpack_public_path__ + "img/Group5.c592bf99.png";